/** @jsx jsx */
import { useState } from 'react';
import { css, jsx } from '@compiled/react';
import Button from '@atlaskit/button';
import { Box, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import InfoIcon from './info-icon';

type Props = {
	date: string;
	tooltip: string;
	swiftIconPosition?: boolean;
	label: string;
};

function DateTooltip(props: Props) {
	const { date, tooltip, swiftIconPosition, label } = props;

	const [showInfo, setShowInfo] = useState<boolean>(false);

	return (
		<Box
			xcss={[dataCellWrapperStyles, swiftIconPosition && swiftIconPositionStyles]}
			onFocus={() => setShowInfo(true)}
			onBlur={() => setShowInfo(false)}
			onMouseEnter={() => setShowInfo(true)}
			onMouseLeave={() => setShowInfo(false)}
		>
			<Box as="span" xcss={[contentStyles]}>
				{date}
			</Box>
			<Tooltip content={tooltip} position="top" tag="span">
				{(tooltipProps) => (
					<Button
						{...tooltipProps}
						appearance="subtle"
						iconBefore={<InfoIcon />}
						spacing="none"
						aria-label={label}
						// eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
						css={[iconButtonStyles, showInfo ? buttonWithOpacity : buttonWithoutWidth]}
					/>
				)}
			</Tooltip>
		</Box>
	);
}

export default DateTooltip;

const dataCellWrapperStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	gap: 'space.025',
});
const swiftIconPositionStyles = xcss({ flexDirection: 'row-reverse' });

const contentStyles = xcss({
	textOverflow: 'ellipsis',
	overflow: 'hidden',
});

const iconButtonStyles = css({
	display: 'flex',
	transition: 'opacity width 0.5s',
	opacity: 0,
});
const buttonWithoutWidth = css({ maxWidth: 0 });
const buttonWithOpacity = css({ opacity: 1 });
